export const GET_USER_HIERARCHY = 'V3_GET_USER_HIERARCHY';
export const GET_HIERARCHIAL_USER_INFO = `V3_HIERARCHIAL_USER_INFO`
export const SET_SELECTED_USER_FOR_USER_HIERARCHY = `V3_SET_SELECTED_USER_FOR_USER_HIERARCHY`
export const UNSET_SELECTED_USER_FOR_USER_HIERARCHY = `V3_UNSET_SELECTED_USER_FOR_USER_HIERARCHY`